/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Worth a look, not a reason to refuse. PRACTICAL_EXAM_VARIES — a part of a practical exam draws fewer questions than it has, so trainees get different exams. SMALL_POOL_WITH_REVIEW — the person sees their mistakes after the test, and the part has fewer than twice the questions it draws, so another attempt brings back much the same questions. FIXED_SET_WITH_REVIEW — the person sees their mistakes, and the part asks the same questions every time (a whole category or questions chosen by hand), so the summary will show the mistakes from that part without their correct answers.
 * @export
 * @enum {string}
 */

export const TestPoolWarningCodeDto = {
    PracticalExamVaries: 'PRACTICAL_EXAM_VARIES',
    SmallPoolWithReview: 'SMALL_POOL_WITH_REVIEW',
    FixedSetWithReview: 'FIXED_SET_WITH_REVIEW'
} as const;

export type TestPoolWarningCodeDto = typeof TestPoolWarningCodeDto[keyof typeof TestPoolWarningCodeDto];



